// Opens the Tidio chat widget when an "Ask an Expert" Live Chat trigger is clicked.
// Guarded so this file stays safe to double-execute (e.g. if a theme's sticky-add-to-cart
// or any other component re-inserts this section's markup elsewhere on the page) —
// without the guard, two identical click listeners would fire the handler twice per click.
if (!window.__askExpertChatBound) {
  window.__askExpertChatBound = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ask-expert-chat-trigger]');
    if (!trigger) return;

    event.preventDefault();

    if (window.tidioChatApi) {
      window.tidioChatApi.show();
      window.tidioChatApi.open();
      return;
    }

    // Tidio's script may still be loading; open as soon as it's ready.
    document.addEventListener(
      'tidioChat-ready',
      function () {
        if (window.tidioChatApi) {
          window.tidioChatApi.show();
          window.tidioChatApi.open();
        }
      },
      { once: true }
    );
  });
}
